export type ListFilter = {
  field: string;
  operator: string;
  value: string;
  displayValue?: string;
  text?: string;
  disabled?: boolean;
}

export type ListSettingDictionary = {
  [key: string]: ListSetting
}

export type ListSetting = {
  columns: string[];
  filters: ListFilter[];
  itemsPerPage?: number;
  sortByField: string;
  sortByOrder: 'ASC' | 'DESC'
}

class FavouritesManager {
  get activeSettings(): ListSettingDictionary {
    try {
      const stored = localStorage.getItem('activeListSettings')
      return stored ? JSON.parse(stored) : {}
    } catch (e) {
      return {}
    }
  }

  set activeSettings(updated) {
    const serialized = JSON.stringify(updated)
    localStorage.setItem('activeListSettings', serialized)
  }

  setSetting(key: string, settings: ListSetting) {
    const current = { ...this.activeSettings }
    current[key] = { ...settings }
    this.activeSettings = current
  }

  unsetSetting(key: string) {
    const current = { ...this.activeSettings }
    delete current[key]
    this.activeSettings = current
  }

  checkSetting(key: string): ListSetting | undefined {
    return this.activeSettings[key]
  }
}

export default new FavouritesManager()
